import React, { useEffect, useState } from "react";
import API from "../../services/api";
import { roles } from "../../utils/constants";
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import { useForm } from "react-hook-form";
import { Toast } from "../../shared/Toast";

function AppStats() {
  const [appData, setAppData] = useState([]);
  const [actionIndex, setActionIndex] = useState(-1);
  const userType = localStorage.getItem("role");
  const [add, setAdd] = useState(false);
  const [editValueIndex, setEditValueIndex] = useState(-1);
  const [editValue, setEditValue] = useState();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ mode: "onSubmit" });
  const fetchAppStats = async () => {
    try {
      let res = await API({
        url: "/stats",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setAppData(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const AddStats = async (data) => {
    console.log(data);
    try {
      let res = await API({
        url: "/stats/add",
        method: "POST",
        responseType: "json",
        data: data,
      });
      if (res.code === 200) {
        setAdd(false);
        setAppData(res.data);
        fetchAppStats();
        reset()
        Toast("success", "Added Successfully");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const onInvalid = (errors) => console.error(errors);

  const upadteStats = async (id) => {
    try {
      let res = await API({
        url: "/stats/update",
        method: "POST",
        responseType: "json",
        data: {
          value: editValue,
          id,
        },
      });
      if (res.code === 200) {
        fetchAppStats();
        Toast("success", "Updated Successfully");
        setEditValueIndex(-1);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const deleteStats = async (id) => {
    try {
      let res = await API({
        url: "/stats/delete",
        method: "POST",
        responseType: "json",
        data: {
          id,
        },
      });
      if (res.code === 200) {
        fetchAppStats();
        Toast("success", "Deleted Successfully");
        setEditValueIndex(-1);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchAppStats();
  }, []);
  return (
    <>
      <h3 className="text-center">
        {userType === roles.ops ? "Add Stats" : "View Stats"}
      </h3>
      {userType === roles.ops ? (
        <>
          <div className="mx-auto">
            {
              <table className="table table-bordered ">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Field Name</th>
                    <th>Value</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {appData?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.field}</td>
                        <td className="gap-3">
                          {editValueIndex === index ? (
                            <input
                              type="text"
                              className="form-control w-auto"
                              value={editValue}
                              onChange={(e) => {
                                setEditValue(e.target.value);
                              }}
                            />
                          ) : (
                            <span>{item.value}</span>
                          )}

                          <span className="icon">
                            {editValueIndex !== index ? (
                              <SlIcon
                                className="cursor-pointer"
                                onClick={() => {
                                  setEditValueIndex(index);
                                  setEditValue(item.value);
                                }}
                                library="lucide"
                                name="pencil"
                              ></SlIcon>
                            ) : null}
                          </span>
                        </td>
                        <td>
                          {
                            <div className="d-flex gap-3">
                              {editValueIndex === index ? (
                                <SlIcon
                                  style={{ color: "green" }}
                                  onClick={() => upadteStats(item.id)}
                                  className="cursor-pointer"
                                  library="lucide"
                                  name="check"
                                ></SlIcon>
                              ) : null}
                              <SlIcon
                                style={{ color: "red" }}
                                onClick={() => deleteStats(item.id)}
                                className="cursor-pointer"
                                library="lucide"
                                name="trash-2"
                              ></SlIcon>
                            </div>
                          }
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            }
            <SlIcon
              style={{ color: "blue", width:"30px" }}
              onClick={() => setAdd(true)}
              className="cursor-pointer"
              library="lucide"
              name="plus-circle"
            ></SlIcon>
            {add ? (
              <div>
                <form
                  className="d-flex gap-3"
                  onSubmit={handleSubmit(AddStats, onInvalid)}
                >
                  <label className="form-label text-nowrap">Field Name</label>
                  <input
                    className="form-control"
                    {...register("field", { required: true })}
                  ></input>
                  <label className="form-label text-nowrap">Value</label>
                  <input
                    className="form-control"
                    {...register("value", { required: true })}
                  ></input>
                  <button type="submit" className="btn btn-success">
                    Save
                  </button>
                  <button className="btn btn-danger" onClick={()=>{setAdd(false);reset()}}>Close</button>
                </form>
              </div>
            ) : null}
            
          </div>
        </>
      ) : (
        <table className="table table-bordered mx-auto">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Field Name</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {appData?.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.field}</td>
                  <td>{item.value}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </>
  );
}

export default AppStats;
